import React, { useMemo } from 'react';

import { Grid } from '@material-ui/core';
import FilterListWrapper from 'core/FiltersDialog/components/FiltersListWrapper';
import { useDialogContext, useFiltersContext } from 'core/FiltersDialog/FiltersDialogContext';
import { flatten, get } from 'lodash';
import { TProvider, useProviderPaginationV2 } from 'ui-model';

import { Chip, ChipLoader, InfiniteScroll } from 'components/v2';

import { LIMIT_REQUEST_PARAM } from './constants';

import FilterEmptyState from '../FilterEmptySate';

interface FilterProvidersListProps {
  type: string;
  params: Object;
}

const FilterProvidersList: React.FC<FilterProvidersListProps> = ({ type, params }) => {
  const { filters, updater } = useFiltersContext();
  const { toggleLockFilters } = useDialogContext();
  const providersUpdater = updater('providers');

  const { data: providers = [], isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useProviderPaginationV2({
    ...params,
  });
  const providersList = useMemo(() => flatten(get(providers, 'pages', [])) as TProvider[], [providers]);
  const providersLength = get(providersList, 'length', 0);
  const isLoadingNext = isLoading || (isFetchingNextPage && providersLength >= LIMIT_REQUEST_PARAM);

  const handleSelectItem = (item: any) => {
    providersUpdater(item._id);
    toggleLockFilters(false);
  };

  const isSelected = (id: string) =>
    (filters[type].includes('all') && !filters[type].includes(id)) ||
    (filters[type].includes('all') && filters[type].length === 1) ||
    (!filters[type].includes('all') && filters[type].includes(id));

  return (
    <FilterListWrapper>
      <InfiniteScroll
        hasNext={Boolean(hasNextPage)}
        isLoadingNext={isFetchingNextPage}
        loadNext={() => fetchNextPage()}
      >
        <Grid container spacing={8}>
          {providersLength === 0 ? (
            <FilterEmptyState />
          ) : (
            providersList
              .filter(({ name }) => name !== '' && name !== undefined)
              .map((item: any) => (
                <Grid item key={item._id}>
                  <Chip
                    color="supportPowder"
                    label={item.name}
                    selected={isSelected(item._id)}
                    onClick={() => handleSelectItem(item)}
                  />
                </Grid>
              ))
          )}
        </Grid>
      </InfiniteScroll>
      {isLoadingNext && <ChipLoader />}
    </FilterListWrapper>
  );
};

export default (props: any) => (
  <React.Suspense fallback={null}>
    <FilterProvidersList {...props} />
  </React.Suspense>
);
